<template>

  <div class="vue-modal fixed top-0 left-0 w-full h-full">
    <div class="vue-modal-inner flex items-center justify-center w-full h-full">
      <div @click="onClose" class="w-full h-full absolute  top-0 left-0 wrapper-m"></div>
      <div class="vue-modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ModalPartials',
  methods: {
    onClose() {
      this.$store.dispatch('TOGGLE_MODAL_STATE', { value: false });
    },
  },
};
</script>
<style scoped>

.vue-modal {
  background: rgba(0, 0, 0, 0.9);
  overflow-x: hidden;
  overflow-y: auto;
  z-index:2;
}

.vue-modal-content {
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 0.3rem;
  padding: 1rem;
}
</style>
